// src/components/fun/messages/messagesData.js

export const advices = [
  "Пий склянку води одразу після пробудження.",
  "Робочий стіл = порядок у голові. Прибери.",
  "Не біжи від проблеми — зроби паузу й поглянь на неї з боку.",
  "Якщо щось можна зробити за 2 хвилини — зроби одразу.",
  "Сон важливіший за каву.",
  "Склади список із 3 найважливіших справ дня. Решта — бонус.",
  "Веди нотатник для думок, які заважають заснути.",
  "Дихай 4–7–8: вдих 4с, затримка 7с, видих 8с.",
  "Використовуй правило 'одна вкладка' в браузері — фокус виросте в рази.",
  "На стрес реагуй рухом, а не соцмережами.",
  "Зранку не бери телефон у руки, поки не привітався з собою.",
  "Твій настрій залежить від твого тіла. Випрямися.",
  "Коли сумно — подякуй вголос за 3 речі.",
  "Став будильник не на підйом, а на 'йди спати'.",
  "Щодня роби прибирання хоча б на 5 хвилин.",
  "Коли пережовуєш думки — випиши їх на папір.",
  "Не змушуй себе — спробуй домовитися з собою.",
  "Відклади вибір одягу зранку — готуй з вечора.",
  "Веди список 'маленьких перемог'.",
  "Смійся над собою — це найкраще заземлення.",
  "Сперечаєшся? Заміни 'але' на 'і'.",
  "Раз на тиждень гуляй без навушників.",
  "Став таймер на 25 хвилин і просто почни робити.",
  "Не завжди треба відповідати — інколи достатньо видихнути.",
  "Не купуй мотивацію — купуй таймер.",
  "Кожен ковток кави — як міні-медитація. Пий повільно.",
  "Починай ранок зі світла — відкрий штори.",
  "Без руху немає ясності. Пройдись кварталом.",
  "Не йди спати сердитим.",
  "Зміни одне слово — замість 'я мушу' кажи 'я обираю'.",
  "Раз на день стрибай. Серйозно.",
  "Втомився? Пройдися по холодній підлозі босоніж.",
  "Не тримай усе в голові — виписуй.",
  "Перш ніж купити — запитай себе, чи це 'потрібно' чи просто 'приємно'.",
  "Якщо не хочеться розмовляти — скажи правду.",
  "Думкам потрібен кисень. Відчини вікно.",
  "Дозволь собі змінювати думку.",
  "Раз на тиждень роби щось уперше.",
  "Говори з собою лагідно — ти чуєш це найчастіше.",
  "Коли не знаєш, що робити — зроби чай.",
  "Не шукай баланс — шукай ритм.",
  "Вибачай людей не для них — для себе.",
  "Навчися казати 'мені потрібно подумати'.",
  "Ваш конфлікт може почекати. А твоє серце — ні.",
  "Твоя енергія цінніша за твою правоту.",
  "Перед відповіддю спитай: 'Я хочу бути правим чи почутим?'.",
  "Не змушуй тіло сидіти, коли воно хоче рухатись.",
  "Їжа — не лише для шлунка, а й для очей. Накрий красиво.",
  "Зміни шпалери на телефоні на щось заспокійливе.",
  "Найтихіші 10 хвилин дня — це твоя терапія.",
  "Переформулюй проблему як задачу з умовою і параметрами.",
  "Заміни «це складно» на «це ново» — м’який рефреймінг.",
  "Скажи собі вголос: «Що тут під моїм контролем?» (стоїцизм).",
  "Знайди 1 дію під контролем і зроби її зараз.",
  "Створи «якір спокою»: дотик до зап’ястка + глибокий вдих.",
  "Зміни внутрішній голос: говори тихіше й доброзичливо.",
  "Піймай катастрофізацію й додай «а що найімовірніше?»",
  "Пиши 3 хороші події дня і чому вони сталися (перепроживання).",
  "Визнач 5 своїх сильних рис і застосуй хоч одну сьогодні.",
  "Плануй найважче на годину піку енергії.",
  "Вчись казати «ні» коротко й тепло.",
  "Використай правило 1%: маленький прогрес щодня.",
  "Якщо застряг — сформулюй ціль у форматі поведінки, не результату.",
  "Зроби добру справу анонімно.",
  "Прогулянка без телефону = перезавантаження кори.",
  "Перед зустріччю: намір «бути цікавим до людини, не до себе».",
  "Замість «чому?» запитай «як саме?» (рішення замість звинувачень).",
  "Відрізняй факти від інтерпретацій.",
  "Веди список «я обрав(ла) не робити» — теж досягнення.",
  "Потрібно поспілкуватися складно? Напиши чернетку і скороти вдвічі.",
  "Тримай обіцянки собі дрібними — і виконуй.",
  "Коли дратує — назви емоцію: «Я злюсь», і зітхни довше за вдих.",
  "Амор фаті: люби те, що вже сталося — і дій далі.",
  "Зроби паузу на 10 свідомих ковтків води.",
  "Ритуал старту роботи: одна і та ж музика/місце/фраза.",
  "Рефрейм «помилка» → «дані для налаштування курсу».",
  "Попроси поради у себе з майбутнього: «Що б я зробив через рік?»",
  "Склади мапу тригерів і відповідей на них.",
  "Сумніви? Зроби «мінімально життєздатну версію» дії.",
  "Дихотомія контролю: відпусти те, що не твоє.",
  "Практикуй вдячність людині подумки перед розмовою.",
  "Заплануй радість: маленький кайф щодня у календарі.",
  "Перевір переконання: «Які докази за? Які проти?»",
  "Нагадування: ти — не твоя думка. Думки приходять і йдуть.",
  "Візуалізуй перешкоду і себе, що її м’яко обходить.",
  "Скасуй самокритику фразою: «Я вчуся» і спитай «що наступне?»",
  "Коли тягне прокрастинувати — зроби 3 хвилини й дай собі зупинитись.",
  "Сторони конфлікту? Опиши позицію опонента краще за нього.",
  "Створи «список живлення»: люди/місця/справи, що наповнюють.",
  "Скажи «дякую» три рази на день різним людям.",
  "Втома рішень? Уніфікуй один рутинний вибір на тиждень.",
  "Налаштуй нічний режим екрану за годину до сну.",
  "Сенс ≠ настрій: роби сенсове навіть без ідеального настрою.",
  "Заміни скрол на 5 сторінок паперової книжки.",
  "Пиши собі лист підтримки від імені друга.",
  "Тримай спину рівно 60 секунд — зміни стан.",
  "Перед «так» запитай: «Від чого я відмовляюсь, погоджуючись?»",
  "Роби паузу на мікро-споглядання: хмари, листя, світло.",
  "Не наздоганяй натхнення — створюй умови для нього.",
  "Нагадування на телефоні: «Повільно — це теж швидко».",
];

export const quotes = [
  "Все буде добре. А якщо ще не добре — значить, це ще не кінець.",
  "Той, хто хоче — шукає можливості. Той, хто не хоче — шукає причини.",
  "Не бійся повільно йти, бійся стояти на місці.",
  "Мрії не працюють, поки не працюєш ти.",
  "Усміхайся — це безкоштовно і працює завжди.",
  "Помилки — це доказ того, що ти пробуєш.",
  "Кожен день — новий шанс почати спочатку.",
  "Ти не запізнився. Ти прийшов у свій час.",
  "Іноді не падає той, хто сильний, а той, кому є за що триматися.",
  "Зроби сьогодні те, за що завтра собі подякуєш.",
  "Ти вже пережив 100% важких днів. Впораєшся й далі.",
  "Хто хоче — знаходить спосіб. Хто не хоче — знаходить виправдання.",
  "Ти не зобов'язаний бути ідеальним, щоб бути цінним.",
  "Навіть маленький крок уперед краще, ніж стояти і думати.",
  "Сумніви вбивають більше мрій, ніж помилки.",
  "Навіть сонце сходить не миттєво — дай собі час.",
  "Твоя історія ще пишеться.",
  "Сили приходять під час руху, а не перед ним.",
  "Якщо не знаєш, з чого почати — почни з себе.",
  "Хтось зараз мріє про те, що ти вже маєш.",
  "Не порівнюй свій початок із чужим фінішем.",
  "Ти можеш не зараз, але ти точно зможеш.",
  "Крок уперед після поразки — це теж перемога.",
  "Навіть найдовший шлях починається з рішення йти.",
  "Не опускай руки — бо саме там ключ до успіху.",
  "Твоя сила не в тому, що ти ніколи не падаєш, а в тому, що піднімаєшся.",
  "Сумніваєшся? Все одно зроби.",
  "Найкращий час — зараз.",
  "Ти не один — просто поки що не всіх зустрів.",
  "Не чекай ідеального моменту — зроби момент ідеальним.",
  "Сьогоднішній крок — завтрашній результат.",
  "Хто шукає світло — той стає світлом.",
  "Не бійся змін — бійся залишитися тим, ким ти більше не хочеш бути.",
  "У тебе вийде. А коли вийде — ти ще й здивуєшся, як легко це було.",
  "Найгірше, що може статися — нічого не зміниться.",
  "Твоя сила починається там, де закінчується страх.",
  "Якщо важко — значить, ти зростаєш.",
  "Те, що ти йдеш повільно, не означає, що ти не йдеш.",
  "Хмари не можуть тривати вічно.",
  "Навіть коли не видно сонця — воно все одно є.",
  "Не здавайся перед фінішем.",
  "Кожне «не виходить» наближає до «вийшло».",
  "Життя — не боротьба, а танець. Дозволь собі іноді просто рухатися.",
  "Ти — своє найкраще «потім».",
  "Світ змінюється, коли змінюєшся ти.",
  "Ти — більше, ніж твої сумніви.",
  "Твоє «сьогодні» — не вирок, а момент.",
  "Плануй маленьке, дій сміливо.",
  "Заміни «страшно» на «незвично».",
  "Дихни. Ти вже тут, і цього досить, щоб почати.",
  "Кожен раз, коли підводишся — переписуєш фінал.",
  "Ти не зламаний — ти в процесі складання.",
  "Не «чому я?», а «для чого мені це?»",
  "Роби добро тихо, і воно кричатиме результатами.",
  "Помилка — це крок уперед, який просто болить.",
  "Завтра легше, коли сьогодні — чесно.",
  "Надія — це теж дія, тільки внутрішня.",
  "Ти не запізнився — твій ритм інший.",
  "Сили не беруться нізвідки — вони ростуть із кроків.",
  "Почни з 5 хвилин. Інше підтягнеться.",
  "Не плутай втому з відсутністю мрії.",
  "Сумнів — не стоп, а сигнал перевірити курс.",
  "Ти маєш право робити повільно.",
  "Твоє «не можу» інколи означає «мені потрібна пауза».",
  "Краще недосконало йти, ніж ідеально стояти.",
  "Вчися радіти малому — з цього будуються великі дні.",
  "Ти — не вчорашні помилки, ти — сьогоднішній вибір.",
  "Коли темно — сядь ближче до себе.",
  "Запитай у себе: «Що якщо в мене вийде?»",
  "Зменш темп, не мрію.",
  "Важко? Порахуй до десяти і лишися на маршруті.",
  "Твій шлях — не змагання, а пригода.",
  "Завжди можна м’якше до себе й твердіше до задачі.",
  "Порівнюй себе тільки з учорашнім собою.",
  "Кожен день має місце для маленької гордості.",
  "Стійкість — це багато «продовжив» замість одного «здався».",
  "Сказати «ні» — це сказати «так» собі.",
  "Повернутись — теж рух, якщо це до себе.",
  "Дозволь собі не знати, але не забороняй дізнатися.",
  "Твоє серце знає шлях. Розум допоможе прокласти.",
  "Перерви лікують продуктивність.",
  "Сміливість звучить як «спробую».",
  "Світ не чекає ідеальних — він чекає присутніх.",
  "Не тримай камінь у руці — він не захист, а тягар.",
  "Твої сльози — теж доказ сили відчувати.",
  "Коли не вистачає віри — позич у дії.",
];

export const memes = [
  "Вчора вирішив 'лягти рано'. Ліг о 23:59. Це ж рано?",
  "Коли кажеш 'ще одна серія' — і вже світанок.",
  "Я: буду економити гроші. Також я: купив каву і ще каву.",
  "Поставив будильник на 7:00, прокинувся о 6:59. Людина-легенда.",
  "Інтернет зник на 5 хвилин. Я встиг подружитися з родиною.",
  "Сьогодні зроблю всі справи! — я, щодня.",
  "Я не відкладаю — я витримую паузу перед геніальністю.",
  "Пішов спати вчасно. А заснув — коли вже пора вставати.",
  "Мій мозок уночі: давай згадаємо всі незручні моменти за 10 років.",
  "Хотів трохи полежати. Прокинувся у 2035.",
  "Я не лінивий — я енергозберігаючий.",
  "Я: треба поприбирати. Також я: дивлюсь відео, як хтось прибирає.",
  "У холодильнику порожньо. Знову доведеться їсти надії й мрії.",
  "Найдовший шлях — це шлях від ліжка до душу.",
  "Я кажу 'так, звісно' замість 'ні', бо я чемний боягуз.",
  "Я — дорослий. Я вирішую. Я нічого не вирішив.",
  "Мій план на день: 1) вижити. 2) якщо пощастить — процвітати.",
  "Включив режим ‘нічого не хочу, але хочу’.",
  "Збирався зробити зарядку. Зарядив телефон.",
  "Сьогодні точно буду продуктивним. *Гортає меми 3 години*",
  "Я не розкидаю речі. Я створюю атмосферу життя.",
  "Уміння знаходити диван у будь-якій ситуації — мій супергеройський дар.",
  "Я: все, з понеділка нове життя. Також я в понеділок: наступного понеділка.",
  "Мій улюблений спорт — переносити справи на завтра.",
  "Кажуть, що сон корисний. Але чому я прокидаюсь ще втомленішим?",
  "— Будеш чай? — Та ні, я тільки водичку. — *Дістаю півкіло печива*", 
  "Я не забудькуватий — у мене вибіркова пам’ять: запам’ятовую меми, але не дедлайни.",
  "Завів список справ. Загубив.",
  "Люблю, коли в календарі немає планів — тоді можу спокійно нічого не робити.",
  "Я: треба економити. Також я: о, доставка безкоштовна при замовленні від 1000 грн!",
  "Моя суперсила — виглядати зайнятим, коли нічого не роблю.",
  "Найперше правило дорослого життя — завжди мати плед.",
  "Хочу пригод, але таких, щоб не вставати з ліжка.",
  "Я: буду пити тільки воду. Також я: вода з кавою теж рахується, правда?",
  "Найскладніше — почати. Найлегше — відкласти.",
  "Я не опізнююсь — я створюю драматичний ефект появи.",
  "Збираюсь бігати вранці. Вже третій рік збираюсь.",
  "Коли життя закидає тебе в стрес — закинь себе в плед.",
  "У кожному з нас живе дорослий. Але у мене він постійно втомлений.",
  "Мій Wi-Fi вранці швидший, ніж я.",
  "Мій настрій залежить від швидкості доставки їжі.",
  "Мрія: поїсти і не поправитись. Реальність: поправитись і не поїсти.",
  "Я не прокрастиную — я стратегічно обдумую.",
  "Я — як додатки на телефоні: відкритий усього на 10%, решта висить у фоні.",
  "Поставив 5 будильників. Прокинувся на шостий — сусідній.",
  "У мене два стани: або «я все встигну», або «я — ковдра».",
  "Планував бігати. Побіг думками — уже втомився.",
  "Мій улюблений фітнес — піднімати самооцінку і опускати очікування.",
  "Я: куплю продукти на тиждень. Також я: чому зникли чипси за 10 хвилин?",
  "Список справ довгий, як чек із доставки.",
  "У мене 48 вкладок відкрито. І жодної сміливості їх закрити.",
  "Пароль складний, як моє життя. Забув обидва.",
  "Поставив оновлення на 5 хвилин. Минуло три епохи.",
  "Кава закінчилась. Починаю говорити повільніше.",
  "Я — ранкова людина, але тільки після обіду.",
  "Зробив план. Тепер він мене лякає з холодильника.",
  "Нарешті прибрав стіл. Загубив натхнення.",
  "Сiri, нагадуй бути геніальним щодня о 10:00.",
  "Смарт-годинник сказав, що я сиджу. Дякую за сюрприз.",
  "Медитував 2 хвилини. Відкрив очі — уже в телефоні.",
  "Я не купую зайвого — я інвестую в радість на 15 хвилин.",
  "Випив воду. Чекаю аплодисменти від організму.",
  "Сьогодні зроблю зарядку. Зарядив… павербанк.",
  "Я: вчу англійську. Також я: «deadline переноситься».",
  "Хочу тарілку салату. На тарілці — піца, але зелена коробка.",
  "Порахував кроки за день. Це були кроки до холодильника.",
  "Холодильник: порожньо. Я: знову уявна кулінарія.",
  "Мій талант — робити вигляд, що я думаю, коли я сплю з відкритими очима.",
  "Кіт сидить на ноуті — офіційна пауза в роботі.",
  "Продуктивність увімкнена. Інтернет: «а давай без цього».",
  "Знайшов ідеальну подушку для спини. Тепер лежу ще продуктивніше.",
  "Включив режим «економія батареї». На собі.",
  "Натиснув «Відкласти». Це про будильник і про життя.",
  "Зустріч могла бути листом. Лист — мемом.",
  "Коли немає сил, я згадую: у мене є крісло.",
  "Сьогодні — день спорту: біг від задач і стрибки до висновків.",
  "Мені потрібен таймер «припини їсти на ніч». І охоронець.",
  "Переставив іконки на телефоні. Нове життя почалось. Ненадовго.",
  "Нарешті закрив усі вкладки. Відкрив нові — заспокоївся.",
  "Ти на дієті? — Так. — Чому з тортом? — Дієта на стреси, торти — настрій.",
  "Обожнюю бути дорослим: можу їсти сніданок на вечерю і ніхто не скаже «ні».",
  "Купив планер. Планую почати планувати із понеділка.",
  "Я — не сова і не жайвір. Я — втомлена качка.",

];